import { render, staticRenderFns } from "./linelossdetail.vue?vue&type=template&id=58bb58a2&"
import script from "./linelossdetail.vue?vue&type=script&lang=ts&"
export * from "./linelossdetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "linelossdetail.vue"
export default component.exports